import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { AddEventInDataBase, AddSkillsInDatabase, AddStaff } from "../../CrudOperations/PostOperation";
import { updateSkillInDataBase } from "../../CrudOperations/Update&Edit";

const AddSkills = ({ closeModal, onSubmit, Staff,onUpdate }) => {



  
  const [SkillName, setSkillName] = useState( Staff ? Staff.SkillName : "");
  const [Status, setStatus] = useState(Staff ? Staff.Status : "Active");




  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if(!Staff) {


      const response = await AddSkillsInDatabase(
        SkillName,
      Status
     );
  
  
     
      if (response?.data?.ServerMessage === "Skill added successfully.") {
        onSubmit(); // Handle new data
      }





    }
    else{

      console.log(SkillName);
      console.log(Status);
      console.log(    Staff.SkillId);
      

      const response = await updateSkillInDataBase(
        SkillName,
        Status,
        Staff.SkillId
     );
     console.log(response);
     
  
  
     
      if (response?.data?.ServerMessage === "Skill updated successfully.") {
        onSubmit(); // Handle new data
      }







    }



    



    
    

   
  };

  return (
    <div className={`fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 ${'block' }`}>
      <div className="bg-white rounded-lg p-4 w-1/3 shadow-lg">
        <h2 className="text-lg font-bold mb-3">
          {Staff ? "Edit Staff" : "Add Skill"}
        </h2>
        <form onSubmit={handleFormSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700">Skill Name *</label>
            <input
              type="text"
              value={SkillName}
              onChange={(e) => setSkillName(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            />
          </div>

         
          <div className="mb-2">
            <label className="block text-gray-700">Status *</label>
             <select
              value={Status}
              onChange={(e) => setStatus(e.target.value)}
            className="border border-gray-300 p-1 w-full rounded-md"
            required

          >
            <option value="">Select Status</option>
               <option key={1} value={1}>
               Active
             </option>

             <option key={0} value={0}>
               InActive
             </option>

             
          </select>
          </div>



          

          <div className="flex justify-end">

            <button
              type="button"
              onClick={closeModal}
              className="bg-gray-300 px-3 py-1 rounded-md mr-2"
            >
              Cancel
            </button>


            <button
              type="submit"
              className="bg-blue-600 text-white px-3 py-1 rounded-md"
            >
              {Staff ? "Update" : "Submit"}
            </button>


          </div>


          
        </form>
      </div>
    </div>
  );
};

export default AddSkills;
